<template>
  <div>
    <b-form>
      <div class="container wizard">
        <div class="row">
          <div class="col-12 p-0">
            <h2>{{ title }}</h2>
          </div>
        </div>

        <validation-observer v-if="typeIdentification" ref="observer" v-slot="{ handleSubmit }">
          <h5>Ingrese por favor el número de {{ typeIdentification }}</h5>
          <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
            <b-row class="mt-4">
              <b-col md="4" cols="12">
                <TextComponent :form="form" name="identification" rules="required" />
              </b-col>
            </b-row>
            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
        <div v-if="message">
          <b-alert show variant="info">
            <i class="info-icon"></i>
            <div style="width: 100%">
              <h4 class="alert-heading"></h4>
              <p class="mb-0">{{ message }}</p>
            </div>
          </b-alert>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import ProcessService from "@/services/process.service";
import moment from "moment";
import TextComponent from "@/components/controls/TextComponent.vue";
import { TIPOS_IDENTIFICACIONES } from "../../../../data/colombia/vida/Selects";

export default {
  components: { TextComponent },

  data() {
    return {
      form: {},
      message: undefined,
      title: "Solicitud Individual Seguro Vida - Colombia",
      typeIdentification: "",
    };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const id = this.$route.params.id ?? "";

    ProcessService.getData(id === "" ? "SN" : id)
      .then((response) => {
        const form = this.initValues({ ...response.formData, processId: id });
        this.$store.dispatch("wizard/save", { index: 0, form, id });
        this.$store.dispatch("app/loading", false);
      })
      .catch((e) => {
        const { message } = (e.response && e.response.data && e.response.data.message) || "";
        this.$store.dispatch("app/loading", false);
        this.message = message || "No se pudo cargar el proceso.";
        this.title = "Proceso finalizado";
      });
  },
  methods: {
    initValues(form) {
      form.birthDayFormat = this.formateValue(form.birthDay);

      const beneficiarioVacio = {
        name: "", lastName: "", documentType: "", document: "",
        birthDay: "", relation: "", percentage: "",
      };
      if (!form.beneficiarios || !Array.isArray(form.beneficiarios)) {
        form.beneficiarios = [
          { ...beneficiarioVacio },
          { ...beneficiarioVacio },
        ];
      } else {
        form.beneficiarios = form.beneficiarios.map((el) => {
          const name = el.name != null && el.name !== "" ? el.name : "";
          const lastName = el.lastName != null && el.lastName !== "" ? el.lastName : "";
          return {
            ...el,
            name,
            lastName,
            birthDay: el.birthDay ? moment(el.birthDay).format("YYYY-MM-DD") : "",
          };
        });
      }

      const typeIdentification = TIPOS_IDENTIFICACIONES.find(
        (e) => e.value === form.identificationType);
        
      this.typeIdentification = typeIdentification ? 
      typeIdentification.text : "Documento de identidad";

      return form;
    },
    formateValue(date) {
      if (date && date !== "") {
        const str = String(date);
        const y = str.substring(0, 4);
        const m = str.substring(4, 6) || str.substring(5, 7);
        const d = str.substring(6, 8) || str.substring(8, 10);
        return `${y}-${m}-${d}`;
      }
      return "";
    },
    next() {
      const { identification } = this.$store.state.wizard.form;

      if (this.form.identification !== identification) {
        this.$bvToast.toast("No coincide el número de identificación", {
          title: "Error de verificación",
          variant: "danger",
          solid: true,
        });
      } else {
        this.$bvToast.toast("Verificación correcta. Complete los datos del asegurado.", {
          title: "Correcta verificación",
          variant: "success",
          solid: true,
        });
        this.$router.push("/form/colombia-vida-1.html");
      }
    },
  },
};
</script>
